import React from 'react';
import { personal } from '../data/portfolioData';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo">
          Shakeel<span className="footer-dot">.</span>
        </div>

        <p className="footer-copy">
          © {year} {personal.name} · Built with React ·{' '}
          <a href={personal.github} target="_blank" rel="noopener noreferrer">
            View on GitHub
          </a>
        </p>

        <div className="footer-links">
          <a href={personal.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href={personal.github}   target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href={`mailto:${personal.email}`}>Email</a>
        </div>
      </div>
    </footer>
  );
}
